/**
 * Guest/costume extras belong on the installment they were added to
 * (usually the next unpaid one), not always June.
 */

export function firstUnpaidInstallmentNum (dancer) {
  const d = dancer || {}
  for (let n = 1; n <= 6; n++) {
    const status = d['payment' + n + 'Status']
    if (status === 'N/A' || status === 'Paid') {
      continue
    }
    return n
  }
  return 0
}

export function guestUsdOnInstallment (n, guests, dancer) {
  const paymentNum = Number(n) || 0
  if (!paymentNum) {
    return 0
  }
  const first = firstUnpaidInstallmentNum(dancer)
  let sum = 0
  ;(guests || []).forEach((g) => {
    if (!g || g.paymentStatus === 'paid') {
      return
    }
    const cost = Number(g.totalCost) || 0
    if (cost <= 0) {
      return
    }
    const assigned = Number(g.addedToPaymentNum) || 0
    if (assigned) {
      if (assigned === paymentNum) {
        sum += cost
      }
      return
    }
    if (g.paymentStatus === 'added_to_next' && first === paymentNum) {
      sum += cost
    }
  })
  return sum
}

export function costumeUsdOnInstallment (n, dancer, costumeDue) {
  if (!(Number(costumeDue) > 0)) {
    return 0
  }
  const method = String((dancer && dancer.costumePaymentMethod) || '')
  if (method !== 'addToNext') {
    return 0
  }
  return firstUnpaidInstallmentNum(dancer) === Number(n) ? Number(costumeDue) : 0
}

export function installmentBreakdownLabel ({ guestUsd = 0, costumeUsd = 0 } = {}) {
  const parts = []
  if (guestUsd > 0) {
    parts.push('$' + guestUsd + ' for your registered guests')
  }
  if (costumeUsd > 0) {
    parts.push('$' + costumeUsd + ' for your costume order')
  }
  return parts.length ? ' + ' + parts.join(' + ') : ''
}

/** Amount to print for the installment itself (guest $ already in paymentNDue). */
export function installmentBaseDue (due, guestUsdOnThisPayment) {
  const raw = Number(due) || 0
  const guests = Math.max(0, Number(guestUsdOnThisPayment) || 0)
  return Math.max(0, raw - guests)
}
